export default __webpack_public_path__ + "static/media/ad-1.4130737f.jpg";